import CryptoJS, { format } from "crypto-js";
import { ArchiveService } from "../WebApiServices/Archive.service";
import ArchiveModel from "../DataModels/ArchiveModel";
import { COHORT_TREATMENT_DISPLAY_MAP, DatePart, Role } from "./Enums";
import dayjs from "dayjs";
const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_KEY);
const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_KEY);

/* <summary>
date: 06-04-2024
Name: AP
description: Get logged in user's ID
<summary>*/
export const GetLoggedInUserID = () => {
  const userId = GetLocalStorageData("userId");
  return Number(userId);
};

/* <summary>
date: 06-04-2024
Name: AP
description: Add data to local storage in encrypted form
<summary>*/
export const AddLocalStorageData = (storageKey, value) => {
  const encryptedValue = EncryptUsingAES256(JSON.stringify(value));
  const encryptedKey = EncryptUsingAES256(storageKey);
  if (localStorage.getItem(storageKey)) {
    localStorage.removeItem(storageKey);
  }
  localStorage.setItem(encryptedKey, encryptedValue);
};

/* <summary>
date: 06-04-2024
Name: AP
description: get decrypted data from local storage
<summary>*/
export const GetLocalStorageData = (storageKey) => {
  const encryptedKey = EncryptUsingAES256(storageKey);
  const encryptedValue = localStorage.getItem(encryptedKey) ?? undefined;
  try {
    if (encryptedValue) {
      return JSON.parse(DecryptUsingAES256(encryptedValue));
    }
  } catch (error) {}
  return encryptedValue;
};

/* <summary>
date: 06-04-2024
Name: AP
description: get decrypted data from local storage
<summary>*/
export const RemoveLocalStorageData = (storageKey) => {
  const encryptedKey = EncryptUsingAES256(storageKey);
  localStorage.removeItem(encryptedKey);
};

/* <summary>
date: 06-04-2024
Name: AP
description: Check if string is empty/undefined/null
<summary>*/
export const isStringEmpty = (text) => {
  try {
    return !text || text.trim().length === 0;
  } catch (error) {}
};
export const isStringEmpty2 = (text) => {
  try {
    text = String(text);
    return text === "null" || !text || text.trim().length === 0;
  } catch (error) {}
};

export const isNumberOrEmpty = (value) => {
  return (
    value === "" || (!isNaN(value) && value !== null && value !== undefined)
  );
};

export const isInvalidNumberOrEmpty = (value) =>
  value === "" || value === null || value === undefined || isNaN(Number(value));

export const isStringEmptyDh = (value) => {
  if (value === 0 || value === "0") return false;
  return (
    value === null || value === undefined || value.toString().trim() === ""
  );
};

/* <summary>
date: 06-04-2024
Name: AP
description: Encryption using CryptoJS
<summary>*/
export const EncryptUsingAES256 = (text) => {
  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), key, {
    iv,
    keySize: 128 / 8,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

/* <summary>
date: 06-04-2024
Name: AP
description: Decryption using CryptoJS
<summary>*/
export const DecryptUsingAES256 = (decString) => {
  const decrypted = CryptoJS.AES.decrypt(decString, key, {
    iv,
    keySize: 128 / 8,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};
/* <summary>
date: 06-04-2024
Name: AP
description: Email Validation
<summary>*/
export const IsEmailValid = (emailAddress) => {
  const emailRegexString =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
  ///^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/; from other ag projects
  return emailRegexString.test(emailAddress);
};

/* <summary>
date: 06-04-2024
Name: AP
description: Validates password
<summary>*/
export const IsPasswordValid = (passowrd) => {
  // const passwordRegexString = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/;
  const passwordRegexString =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
  return passwordRegexString.test(passowrd);
};
/* <summary>
date: 06-04-2024
Name: AP
description: Common fn calling archive service to add archive
<summary>*/
export const AddArchiveFunction = (actionNumber, data, userId, secondaryId) => {
  const payLoad = new ArchiveModel();
  payLoad.archiveaction = actionNumber;
  payLoad.archivedata = data;
  payLoad.userid = userId;
  payLoad.secondaryid = secondaryId;
  //payLoad.CreatedBy = userId;

  ArchiveService.AddArchive(payLoad);
};

//Allow only positive integers
//Value being passed shouldn't be blank
export const AllowOnlyIntegers = (value) => {
  const NUMBER_REGEX = /^[0-9\b]+$/;
  return NUMBER_REGEX.test(value);
};
//Allow only positive Decimals max 2 places
export const AllowPositiveDecimalNumbers = (value) => {
  const NUMBER_REGEX = /^[0-9]*(\.[0-9]{0,2})?$/;
  return NUMBER_REGEX.test(value);
};

//Allow only positive Decimals max 2 places
export const AllowPositiveDecimalsUpToOnePlace = (value) => {
  const NUMBER_REGEX = /^\d+(\.\d{0,1})?$/;
  return NUMBER_REGEX.test(value);
};

//Allow only positive Decimals max 1 places
export const AllowNumberWithOneDecimal = (value) => {
  const NUMBER_REGEX =
    /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;
  //const NUMBER_REGEX = /^(?!0(\.0)?$)([1-9]\d?(\.\d)?|[1-9]\d{0,1}|[1-9]\d{0,1}\.|[1-9]\d?\.|\d|100(\.0?)?|[1-9]\d(\.\d)?|2[0-9]{1,2}(\.\d)?|300(\.0)?)$/;

  return NUMBER_REGEX.test(value);
};

//Allow only one Decimals
export const AllowOnlyOneDecimal = (value) => {
  let parsedValue = parseFloat(value);
  let decimalPart = value.split(".")[1];
  // Check if there are exactly two digits after the decimal
  if (decimalPart.length === 2) {
    parsedValue = value.split(".")[0] + "." + decimalPart.slice(0, 1); // Round to one decimal place
    value = parsedValue.toString();
  }
  return value;
};

//Allow only two Decimals
export const AllowOnlyTwoDecimal = (value) => {
  let parsedValue = parseFloat(value);
  let decimalPart = value.split(".")[1];
  // Check if there are exactly two digits after the decimal
  if (decimalPart.length === 3) {
    parsedValue = value.split(".")[0] + "." + decimalPart.slice(0, 2); // Round to one decimal place
    value = parsedValue.toString();
  }
  return value;
};

export const GetRandomAlphaNumber = () => {
  const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const randomIndex = Math.floor(Math.random() * alphabets.length);
  const letter = alphabets[randomIndex];
  return letter;
};

//Check if value is within allowed bounds. Both the bounds are inclusive
export const ValueInRange = (value, lowLim, highLim) => {
  return value >= lowLim && value <= highLim;
};

/* <summary>
  date: 18-07-2024
  Name: VK
  description: Date Validation
  <summary>*/

export function convertDateFormat(dateString) {
  // Split the date string by "-"
  const [month, day, year] = dateString.split("-");

  // Return the date string in "MM/DD/YYYY" format
  return `${month}/${day}/${year}`;
}

export function validateRadiotherapyDate(date, cohortIndexDate) {
  // Helper function to parse date string in "MM/DD/YYYY" format
  function parseDate(dateString) {
    const [month, day, year] = dateString.split("/");
    return new Date(year, month - 1, day);
  }

  //const requiredCohortIndexDate = convertDateFormat(cohortIndexDate);

  // Convert the input dates to Date objects
  const radiotherapyDate = parseDate(date);
  const indexDate = parseDate(cohortIndexDate);

  // Validate the parsed dates
  if (isNaN(radiotherapyDate) || isNaN(indexDate)) {
    return false; // Invalid date format
  }

  // Calculate the date 91 days before the NDMM index date
  const ninetyOneDaysBeforeIndexDate = new Date(indexDate);
  ninetyOneDaysBeforeIndexDate.setDate(indexDate.getDate() - 91);

  // Check if the last radiotherapy date is within the range
  if (
    radiotherapyDate >= ninetyOneDaysBeforeIndexDate &&
    radiotherapyDate <= indexDate
  ) {
    return true; // Valid
  } else {
    return false; // Invalid
  }
}

// Utility function to calculate the difference in days between two dates
//Check ((NDMM index date – date of birth) < 6575 days) for S6. in NDMM Criteria Page
export const calculateDaysDifference = (birthDate, IndexDate) => {
  const birth = new Date(birthDate);
  const ndmmIndex = new Date(IndexDate);

  // Calculate the time difference in milliseconds
  const differenceInTime = ndmmIndex.getTime() - birth.getTime();

  // Convert time difference from milliseconds to days
  const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);

  return differenceInDays;
};

//Check for validation of conditions in S6. NDMM
export const checkEligibileCohortTreatment = (indexDate, cutoffDate) => {
  if (!indexDate) return false;
  // const dateFormat = 'MM/DD/YYYY';
  // const ndmmIndexDate = moment(indexDate).format(dateFormat);
  // const cutoff = moment(cutoffDate).format(dateFormat);

  const ndmmIndexDate = new Date(indexDate);
  const cutoff = new Date(cutoffDate);

  // Set both dates to 00:00:00 to ignore the time part
  // ndmmIndexDate.setHours(0, 0, 0, 0);
  //cutoff.setHours(0, 0, 0, 0);

  const isEligible = ndmmIndexDate < cutoff;

  return isEligible;
};

// Function to subtract 183 days from a given date and format as MMDDYYYY
export const formatDateMMDDYYYY = (dateString) => {
  // Create a Date object from the dateString
  let initialDate = new Date(dateString);

  // Subtract 183 days
  initialDate.setDate(initialDate.getDate() - 183);

  // Format the date as MMDDYYYY
  let formattedDate = `${(initialDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${initialDate
    .getDate()
    .toString()
    .padStart(2, "0")}/${initialDate.getFullYear()}`;

  return formattedDate;
};

//Check ((Bispecifics/CAR-T index date – date of birth) >= 6575 days) for S11. in RRMM Criteria Page

export const calculateDaysDifferenceRRMM = (birthDate, rrmmIndexDate) => {
  const birth = new Date(birthDate);

  const rrmmIndex = new Date(rrmmIndexDate);

  // Calculate the time difference in milliseconds

  const differenceInTime = rrmmIndex.getTime() - birth.getTime();

  // Convert time difference from milliseconds to days

  const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);

  return differenceInDays;
};

//Check if Bispecifics/CAR-T index date” > “NDMM index date” if “NDMM index date” is not missing in S11. RRMM Criteria

export const checkCARTDate = (rrmmIndexDate, ndmmIndexDate) => {
  const rrmmIndex = new Date(rrmmIndexDate);

  const ndmmIndex = new Date(ndmmIndexDate);

  // Set both dates to 00:00:00 to ignore the time part

  rrmmIndex.setHours(0, 0, 0, 0);

  ndmmIndex.setHours(0, 0, 0, 0);

  const isEligible = rrmmIndex <= ndmmIndex;

  if (ndmmIndexDate === null) {
    isEligible = false;
  }

  return isEligible;
};

export function validateMeasurementDate(date, cohortIndexDate) {
  // Helper function to parse date string in "MM/DD/YYYY" format
  function parseDate(dateString) {
    const [month, day, year] = dateString.split("/");
    return new Date(year, month - 1, day);
  }

  const requiredCohortIndexDate = convertDateFormat(cohortIndexDate);

  // Convert the input dates to Date objects
  const radiotherapyDate = parseDate(date);
  const indexDate = parseDate(requiredCohortIndexDate);

  // Validate the parsed dates
  if (isNaN(radiotherapyDate) || isNaN(indexDate)) {
    return false; // Invalid date format
  }

  // Calculate the date 365 days before the NDMM/RDMM index date
  const daysBeforeIndexDate = new Date(indexDate);
  daysBeforeIndexDate.setDate(indexDate.getDate() - 365);

  // Check if the last radiotherapy date is within the range
  if (
    radiotherapyDate >= daysBeforeIndexDate &&
    radiotherapyDate <= indexDate
  ) {
    return true; // Valid
  } else {
    return false; // Invalid
  }
}

export function validateInputDateWithCohortTmDates(
  inputDate,
  cohortIndexDate,
  cohortIndexDateMinus91,
) {
  // Helper to parse date in MM/DD/YYYY format
  function parseDate(dateString) {
    const [month, day, year] = dateString.split("/");
    return new Date(year, month - 1, day);
  }

  const inputDt = parseDate(inputDate);
  const cohortIndexDt = parseDate(cohortIndexDate);
  const cohortIndexDateMinus91Dt = parseDate(cohortIndexDateMinus91);

  // Validate parsed dates
  if (
    isNaN(inputDt) ||
    isNaN(cohortIndexDt) ||
    isNaN(cohortIndexDateMinus91Dt)
  ) {
    return false;
  }

  // Check if input date is within the range
  return inputDt >= cohortIndexDateMinus91Dt && inputDt <= cohortIndexDt;
}

/* <summary>
  date: 21-07-2024
  Name: NN
  description: Function to subtract 365 days from a given date and format as MMDDYYYY
  <summary>*/

export const formatDate = (dateString) => {
  // Create a Date object from the dateString
  let initialDate = new Date(dateString);

  // Subtract 183 days
  initialDate.setDate(initialDate.getDate() - 365);

  // Format the date as MMDDYYYY
  let formattedDate = `${(initialDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${initialDate
    .getDate()
    .toString()
    .padStart(2, "0")}/${initialDate.getFullYear()}`;

  return formattedDate;
};

/* <summary>
date: 23-07-2024
Name: AP
description: Gets the ordinal value of a number
<summary>*/
export const GetOrdinal = (n) => {
  let suffix;
  const lastDigit = n % 10;
  const lastTwoDigits = n % 100;
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    suffix = "th";
  } else {
    switch (lastDigit) {
      case 1:
        suffix = "st";
        break;
      case 2:
        suffix = "nd";
        break;
      case 3:
        suffix = "rd";
        break;
      default:
        suffix = "th";
        break;
    }
  }
  return (
    <span>
      {n}
      <sup>{suffix}</sup>
    </span>
  );
};

/* <summary>
date: 30-07-2024
Name: VK
description: 
<summary>*/

export const CompareEndofFollowUpDate = (
  date,
  EndofFollowUpDate,
  lastPatientEncounter,
) => {
  // Helper function to parse date strings into Date objects
  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const [month, day, year] = dateStr.split("/");
    return new Date(year, month - 1, day);
  };

  // Parse the given date
  const givenDate = parseDate(date);
  const endDate = parseDate(EndofFollowUpDate);
  const lastEncounterDate = parseDate(lastPatientEncounter);

  // Check if the given date is valid
  if (!givenDate) {
    return false;
  }

  // If both EndofFollowUpDate and lastPatientEncounter are empty, return true
  if (!EndofFollowUpDate && !lastPatientEncounter) {
    return true;
  }

  // If EndofFollowUpDate is empty but lastPatientEncounter is not, return true
  if (!EndofFollowUpDate) {
    return true;
  }

  // Check if the end date is valid
  if (!endDate) {
    return false;
  }

  // Determine the comparison date
  const comparisonDate =
    lastEncounterDate && lastEncounterDate < endDate
      ? lastEncounterDate
      : endDate;

  // Compare givenDate with the comparison date
  return givenDate <= comparisonDate;
};

export function CheckDateValidation(
  DateParameter1,
  DateParameter2,
  DateParameter3,
) {
  const Date1 = DateParameter1 ? parseDate(DateParameter1) : null;

  const Date2 = DateParameter2 ? parseDate(DateParameter2) : null;

  const Date3 = DateParameter3 ? parseDate(DateParameter3) : null;

  // Ensure all dates are valid before comparison
  if (Date1 && Date2 && Date3) {
    return Date1 <= Date2 && Date2 <= Date3;
  }

  // If any of the dates are invalid, return false
  return false;
}

export function IsValidDateSequence(dob, initialDiagnosis, lastEncounter) {
  const parseDate = (d) => {
    if (!d) return null;
    const date = new Date(d);
    return isNaN(date) ? null : date;
  };

  const dobDate = parseDate(dob);
  const diagnosisDate = parseDate(initialDiagnosis);
  const lastEncounterDate = parseDate(lastEncounter);

  // Compare only when both dates exist
  if (dobDate && diagnosisDate && dobDate > diagnosisDate) return false;
  if (diagnosisDate && lastEncounterDate && diagnosisDate > lastEncounterDate)
    return false;

  return true;
}

export function CheckDateValidationQ36(
  DateParameter1,
  DateParameter2,
  DateParameter3,
  DateParameter4,
) {
  const dates = [DateParameter1, DateParameter2, DateParameter3, DateParameter4]
    .map((d) => (d ? parseDate(d) : null))
    .filter((d) => d !== null && !isNaN(d));

  // If 0 or 1 valid dates → nothing to compare, so valid
  if (dates.length <= 1) {
    return true;
  }

  // Ensure dates are in non-decreasing order
  for (let i = 1; i < dates.length; i++) {
    let prevDate = dates[i - 1];
    let currentDate = dates[i];
    if (prevDate > currentDate) {
      return false;
    }
  }

  return true;
}

export function CheckBispecificDateValidation(
  DateParameter1,
  DateParameter2,
  DateParameter3,
  DateParameter4,
  DateParameter5,
) {
  const Date1 = DateParameter1 ? parseDate(DateParameter1) : null;
  const Date2 = DateParameter2 ? parseDate(DateParameter2) : null;
  const Date3 = DateParameter3 ? parseDate(DateParameter3) : null;
  const Date4 = DateParameter4 ? parseDate(DateParameter4) : null;
  const Date5 = DateParameter5 ? parseDate(DateParameter5) : null;

  // Ensure all dates are valid before comparison
  if (Date1 && Date2 && Date3 && Date4 && Date5) {
    return Date1 <= Date2 && Date2 <= Date3 && Date3 <= Date4 && Date4 <= Date5;
  }

  // If any of the dates are invalid, return false
  return false;
}

const parseDate = (dateStr) => {
  if (!dateStr) return null;
  const [month, day, year] = dateStr.split("/");
  return new Date(year, month - 1, day);
};

/* <summary>
date: 29-07-2024
Name: AP
description: Checks if date1 is beyond date2
//Both dates should be valid
<summary>*/
export const IsDateAfter = (dateStr1, dateStr2) => {
  if (isStringEmpty(dateStr1) || isStringEmpty(dateStr2)) {
    return false;
  }

  const date1 = new Date(dateStr1);
  const date2 = new Date(dateStr2);

  // Check if dates are valid
  const isValidDate = (date) => date instanceof Date && !isNaN(date.getTime());

  if (isValidDate(date1) && isValidDate(date2)) {
    return date1 > date2;
  }
  return false;
};

export function checkValue(value) {
  if (typeof value === "number" && value >= 0 && value <= 20) {
    return value;
  }
  return "";
}

export const IsDateLessThanFortyDays = (admissionDateStr, dischargeDateStr) => {
  if (!admissionDateStr || !dischargeDateStr) {
    return false;
  }

  const admissionDate = new Date(admissionDateStr);
  const dischargeDate = new Date(dischargeDateStr);

  // Validate dates
  const isValidDate = (date) => date instanceof Date && !isNaN(date.getTime());
  if (!isValidDate(admissionDate) || !isValidDate(dischargeDate)) {
    return false;
  }

  // Calculate difference in days
  const diffMs = dischargeDate.getTime() - admissionDate.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);

  return diffDays < 40; // true if less than 40 days
};

export const IsDateLessThanThirtyDays = (
  admissionDateStr,
  dischargeDateStr,
) => {
  if (!admissionDateStr || !dischargeDateStr) {
    return false;
  }

  const admissionDate = new Date(admissionDateStr);
  const dischargeDate = new Date(dischargeDateStr);

  // Validate dates
  const isValidDate = (date) => date instanceof Date && !isNaN(date.getTime());
  if (!isValidDate(admissionDate) || !isValidDate(dischargeDate)) {
    return false;
  }

  // Calculate difference in days
  const diffMs = dischargeDate.getTime() - admissionDate.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);

  return diffDays < 30; // true if less than 40 days
};

export function getMaxFirstDate(agentData) {
  const validDates = agentData
    .map((item) => item.firstDate)
    .filter((date) => date !== null)
    .map((date) => {
      const newDate = new Date(date);
      return isNaN(newDate) ? null : newDate; // Check if the date is valid
    })
    .filter((date) => date !== null); // Filter out any null values after conversion

  if (validDates.length === 0) {
    return null; // No valid dates found
  }

  const maxDate = validDates.reduce((latest, current) =>
    current > latest ? current : latest,
  );
  return maxDate;
}

export function getMaxLastDate(agentData) {
  const validDates = agentData
    .map((item) => item.lastDate)
    .filter((date) => date !== null)
    .map((date) => {
      const newDate = new Date(date);
      return isNaN(newDate) ? null : newDate; // Check if the date is valid
    })
    .filter((date) => date !== null); // Filter out any null values after conversion

  if (validDates.length === 0) {
    return null; // No valid dates found
  }

  const maxDate = validDates.reduce((latest, current) =>
    current > latest ? current : latest,
  );
  return maxDate;
}

/* <summary>
date: 12-08-2024
Name: AP
description: Get the earliest date
<summary>*/
export function GetEarliestDate(dateStrings) {
  // Convert date strings to Date objects and filter out invalid dates or empty dates
  const dateObjects = GetDateObjects(dateStrings);

  // Return the earliest date, if any valid dates exist
  if (dateObjects.length === 0) {
    return null;
  }
  return new Date(Math.min(...dateObjects.map((date) => date.getTime())));
}
function GetDateObjects(dateStrings) {
  return dateStrings
    .map((dateStr) => (dateStr ? new Date(dateStr) : null))
    .filter((date) => date instanceof Date && !isNaN(date.getTime()));
}
/* <summary>
date: 13-08-2024
Name: AP
description: Format date to display
<summary>*/
export const DateDisplayFormat = (date) => {
  const dateObj = new Date(date);

  // Check if the date is valid
  if (!isNaN(dateObj.getTime())) {
    // Format the date components
    const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(dateObj.getDate()).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${month}/${day}/${year}`;
  } else {
    // Return null for invalid dates
    return null;
  }
};

export function isValidNumberRange(value) {
  // Convert value to a number
  const number = parseFloat(value);

  // Regular expression to match numbers with up to two decimal places
  // const decimalRegex = /^\d{1,2}(\.\d{1,2})?$|^50(\.0{1,2})?$/;
  const decimalRegex = /^\d{1,4}(\.\d{1,2})?$/;

  // Validate that the number is within the range and matches the decimal format
  return (
    !isNaN(number) && number > 0 && number <= 4000 && decimalRegex.test(value)
  );
}

export function DateInRange(date, minDate, maxDate) {
  return dayjs(date).isAfter(minDate) && dayjs(date).isBefore(maxDate);
}

export function IsDateValid(
  date,
  minDate = dayjs("01-01-1920"),
  maxDate = dayjs(),
) {
  if (date === "Invalid Date") {
    return false;
  }
  return dayjs(date).isAfter(minDate) && dayjs(date).isBefore(maxDate);
}
/* <summary>
date: 29-10-2024
Name: AP
description: Checks if logged in user is Admin
<summary>*/
export function IsAdmin() {
  let userDetails = GetLocalStorageData("user");
  userDetails = userDetails && JSON.parse(userDetails);
  const roleId = userDetails?.userRole ?? 0;
  const isAdmin = roleId === Role.Admin ?? false;
  return isAdmin;
}

export const IsLessOrEqual = (d1, d2) => {
  if (!d1 || !d2) return true;
  return parseDate(d1) <= parseDate(d2);
};

export const IsDateLessThan = (d1, d2) => {
  if (!d1 || !d2) return true;
  return parseDate(d1) < parseDate(d2);
};

export function CalculateAge(dob, referenceDate) {
  const birth = new Date(dob);
  const ref = new Date(referenceDate);

  let age = ref.getFullYear() - birth.getFullYear();

  // Adjust if birthday hasn't occurred yet this year
  if (
    ref.getMonth() < birth.getMonth() ||
    (ref.getMonth() === birth.getMonth() && ref.getDate() < birth.getDate())
  ) {
    age--;
  }

  return age;
}

export const AllowNumericWithDecimal = (e) => {
  const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"];

  // Allow control keys
  if (allowedKeys.includes(e.key)) {
    return;
  }

  // Allow only numbers and '.'
  if (!/^[0-9.]$/.test(e.key)) {
    e.preventDefault();
    return;
  }

  const value = e.target.value || "";
  const selectionStart = e.target.selectionStart ?? value.length;
  const selectionEnd = e.target.selectionEnd ?? value.length;

  const newValue =
    value.slice(0, selectionStart) + e.key + value.slice(selectionEnd);

  // Prevent multiple decimals
  if (e.key === "." && value.includes(".")) {
    e.preventDefault();
    return;
  }

  // Prevent '.' as first character
  if (e.key === "." && value === "") {
    e.preventDefault();
    return;
  }

  // Allow max 2 digits after decimal
  if (newValue.includes(".") && newValue.split(".")[1].length > 2) {
    e.preventDefault();
  }
};

export const IsValidDateValue = (d) =>
  d && d !== "" && d !== "Invalid Date" && !isNaN(parseDate(d));

export const IsDateBeforeCutoff = (dateValue, cutoffDate) => {
  if (!dateValue) return true;

  const d = new Date(dateValue);
  const c = new Date(cutoffDate);

  // Normalize to DATE ONLY
  d.setHours(0, 0, 0, 0);
  c.setHours(0, 0, 0, 0);

  return d < c;
};

export function IsDateChainValid(...dates) {
  const parsedDates = dates.filter(Boolean).map((d) => {
    const date = new Date(d);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()); // date-only
  });

  // If fewer than 2 dates exist, nothing to compare → valid
  if (parsedDates.length < 2) return true;

  for (let i = 0; i < parsedDates.length - 1; i++) {
    if (parsedDates[i] > parsedDates[i + 1]) {
      return false;
    }
  }

  return true;
}

export const AllowOnlyNonZeroNumeric = (e) => {
  // Allow control keys
  const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"];

  if (allowedKeys.includes(e.key)) {
    return;
  }

  // Allow only digits
  if (!/^[0-9]$/.test(e.key)) {
    e.preventDefault();
    return;
  }

  const input = e.target;
  const value = input.value;
  const selectionStart = input.selectionStart || 0;
  const selectionEnd = input.selectionEnd || 0;

  const newValue =
    value.slice(0, selectionStart) + e.key + value.slice(selectionEnd);

  // Prevent leading zero if more than one digit
  if (newValue.length > 1 && newValue.startsWith("0")) {
    e.preventDefault();
  }
};

export const getCohortTreatmentDisplayName = (cohortTreatmentId) => {
  return COHORT_TREATMENT_DISPLAY_MAP[cohortTreatmentId] ?? "";
};

export const handleDecimalKeyDown = (e) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "Escape",
    "Enter",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
  ];

  // Allow copy/paste shortcuts (Ctrl+C, Ctrl+V, Ctrl+A, Ctrl+X)
  if (e.ctrlKey || e.metaKey) return;

  const currentValue = e.target.value;
  const cursorPosition = e.target.selectionStart;

  // Allow control keys
  if (allowedKeys.includes(e.key)) return;

  // Prevent non-numeric keys (except decimal point)
  if (!/^[0-9.]$/.test(e.key)) {
    e.preventDefault();
    return;
  }

  // Prevent multiple decimal points
  if (e.key === "." && currentValue.includes(".")) {
    e.preventDefault();
    return;
  }

  // Prevent more than 2 decimal places
  if (currentValue.includes(".")) {
    const decimalIndex = currentValue.indexOf(".");
    const decimalPlaces = currentValue.length - decimalIndex - 1;

    // If cursor is after decimal and already 2 decimals, prevent additional digits
    if (
      cursorPosition > decimalIndex &&
      decimalPlaces >= 2 &&
      /^[0-9]$/.test(e.key)
    ) {
      e.preventDefault();
      return;
    }
  }
};

export const cleanDecimalInput = (value) => {
  if (!value) return "";

  let cleaned = String(value).replace(/[^0-9.]/g, "");

  const parts = cleaned.split(".");
  if (parts.length > 2) {
    cleaned = parts[0] + "." + parts[1];
  }

  if (parts.length === 2 && parts[1].length > 2) {
    cleaned = parts[0] + "." + parts[1].substring(0, 2);
  }

  return cleaned;
};

export const getEarliestCartDate = (dates) => {
  const parsedDates = dates.filter(Boolean).map((d) => {
    const [m, d1, y] = d.split("/").map(Number);
    return new Date(y, m - 1, d1);
  });

  if (!parsedDates.length) return "";

  const earliest = new Date(Math.min(...parsedDates));
  return earliest.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

export const AllowOnlNumeric = (e) => {
  // Allow control keys
  const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"];
  if (
    !allowedKeys.includes(e.key) &&
    ([".", "e", "+", "-", "E"].includes(e.key) ||
      (e.key.length === 1 && !/[0-9]/.test(e.key)))
  ) {
    e.preventDefault();
  }
};

export function ValidateQ26LastAdministrationMatch({
  isSelected,
  details = [],
  cohortId,
  dateField,
  q26Data = [],
}) {
  if (!isSelected || !details?.length || details?.length === 1) return true;

  // Find Q26 record for this agent
  const agentQ26 = q26Data.find((x) => x.cohortTreatmentId === cohortId);

  if (!agentQ26?.lastAdministrationDt) return true;

  // Only consider doses where a date exists
  const doseDates = details.map((x) => x[dateField]).filter(Boolean);

  if (!doseDates.length) return true;

  const normalizeDate = (date) => new Date(date).toISOString().split("T")[0];
  const normalizedLastAdmin = normalizeDate(agentQ26.lastAdministrationDt);

  // Return true if at least one dose matches the last admin date
  return doseDates.some((date) => normalizeDate(date) === normalizedLastAdmin);
}
